/*
  Maps navigation modules to the entity types they contain. Used by landing page
  components to scope recently-viewed items and alerts per module.
*/

import { ItemType } from '@/types';

// Identifies each top-level navigation module.
export enum ModuleId {
  Home = 'home',
  Portfolio = 'portfolio',
  Investors = 'investors',
  Fundraising = 'fundraising',
  Forecasting = 'forecasting',
  Reports = 'reports',
  Administration = 'administration',
}

/**
 * Maps each module to the ItemType codes of entities that belong to it.
 * null means all entity types (used by the home page).
 * An empty array means the module has no trackable entity types yet.
 */
export const MODULE_ENTITY_TYPES: Record<ModuleId, ItemType[] | null> = {
  [ModuleId.Home]: null,
  [ModuleId.Portfolio]: [ItemType.Company, ItemType.Fund, ItemType.FundGroup, ItemType.Security],
  [ModuleId.Investors]: [ItemType.Investor],
  [ModuleId.Fundraising]: [],
  [ModuleId.Forecasting]: [ItemType.Forecast],
  [ModuleId.Reports]: [ItemType.Report],
  [ModuleId.Administration]: [],
};
